import * as Yup from "yup";

export interface ContactFormData {
  agree: boolean;
  realAgree: boolean;
  startTime: Date;
  name: string;
  email: string;
  subject: string;
  message: string;
}

export const ContactFormDataSchema = Yup.object().shape({
  agree: Yup.boolean().required(),
  realAgree: Yup.boolean().oneOf([true], "You must agree to the terms").required(),
  startTime: Yup.date().required(),
  name: Yup.string().required(),
  email: Yup.string().email("Invalid email address").required(),
  subject: Yup.string().required(),
  message: Yup.string().required(),
});
